module.exports = __webpack_public_path__ + "static/media/tanmay_patil.7307c8ca.png";